module.exports = __webpack_public_path__ + "media/Video 89.3d9e8d45.mp4";